import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Sessions', prop: 'sessions_count' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const Programs = (props) => (
  <List
    title='Programs'
    apiPath='admin/programs'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Programs
